export function resolveDashboardLocale(language: string | undefined) {
	return language === 'it' ? 'it-IT' : 'en-US'
}

export function formatDashboardNumber(value: number, locale: string) {
	return new Intl.NumberFormat(locale).format(value)
}

export function formatDashboardDate(value: string, locale: string) {
	return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(
		new Date(value)
	)
}

export function dashboardPercentage(value: number, maximum: number) {
	return maximum === 0
		? 0
		: Math.min(100, Math.round((value / maximum) * 100))
}
